import { unzipSync } from 'fflate';

/**
 * Description:
 * This functions decompressed .zip file and returns an object with properties success: {} and ignored []
 * success contains the allowed files and their properties
 * ignored contains the names of the ignored files
 * @param {File} compressedZipFile - Zip file to be decompressed
 * @param {string[]} allowedFileExtensions - Allowed extensions to be added to success, not allowed are ignored and returned
 * @returns {{ignored: *[], success: {}}} Success contains the fileName and it's properties, ignored contains the fileNames
 */
const decompressAndDecodeZipFiles = (compressedZipFile, allowedFileExtensions = [] ) => {
  const decompressedFiles = unzipSync(new Uint8Array(compressedZipFile));
  const textDecoder = new TextDecoder('utf-8');
  let decodedFiles = {
    success: {},
    ignored: []
  };

  Object.keys(decompressedFiles).forEach(fileName => {

    // Checks if it a directory, if it ignore it
    if (fileName.includes('/')) {
      decodedFiles.ignored.push(fileName);
      return;
    }

    if(allowedFileExtensions?.length > 0) {
      if(allowedFileExtensions?.some(extension => fileName.includes(extension))) {
        const fileContent = textDecoder.decode(decompressedFiles[fileName]);
        decodedFiles.success = {
          ...decodedFiles.success,
          [fileName]: fileContent
        };
      }else{
        decodedFiles.ignored = [
          ...decodedFiles.ignored,
          fileName
        ];
      }
    } else {
      const fileContent = textDecoder.decode(decompressedFiles[fileName]);
      decodedFiles.success = {
        ...decodedFiles.success,
        [fileName]: fileContent
      };
    }

  });

  return decodedFiles;
};

export default decompressAndDecodeZipFiles;
